import { useAuthTranslations } from './useAuthTranslations';

const INVALID_CREDENTIALS = 'INVALID_CREDENTIALS';

export const useErrorMessage = () => {
  const [translations] = useAuthTranslations();

  const errorMapping: Record<string, () => string> = {
    __proto__: null,
    [INVALID_CREDENTIALS]: () => translations.errorWrongCredentials(),
  };

  return function errorMessage(error: string): string {
    const translationFn = errorMapping[error];
    return translationFn ? translationFn() : error;
  };
};
